import { render, staticRenderFns } from "./vendorContacts.vue?vue&type=template&id=28f61cc8&scoped=true"
import script from "./vendorContacts.vue?vue&type=script&lang=js"
export * from "./vendorContacts.vue?vue&type=script&lang=js"
import style0 from "./vendorContacts.vue?vue&type=style&index=0&id=28f61cc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f61cc8",
  null
  
)

export default component.exports